import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { go } from 'connected-react-router';
import PropTypes from 'prop-types';
// jl-design-system
import Modal from 'jl-design-system/components/modal/Modal';
import { SecondaryButton } from 'jl-design-system/elements/button/Button';
import { PrimaryLink } from 'jl-design-system/elements/link/Link';
import { closeLeaveCheckoutModal } from '../../redux/actions/app/appActions';
import appConstants from '../../constants/appConstants';
import returnToJL from '../../utils/helpers/returnToJL';
// styles
import styles from './leave-checkout-modal.scss';

export class LeaveCheckoutModal extends PureComponent {

  static propTypes = {
    closeLeaveCheckoutModal: PropTypes.func,
    go: PropTypes.func,
    showModal: PropTypes.bool,
  };

  static defaultProps = {
    closeLeaveCheckoutModal: window.defaultFunc,
    go: window.defaultFunc,
    showModal: false,
  };

  handleCloseModal = () => {
    const { go, closeLeaveCheckoutModal } = this.props;
    closeLeaveCheckoutModal();
    go(-1);
  }

  render() {

    const {
      showModal,
    } = this.props;

    if (!showModal) {
      return null;
    }

    return (
      <Modal
        a11yHeader="Are you sure you want to leave checkout?"
        className={styles.modal}
        isOpen
        onClose={this.handleCloseModal}
        rootId={appConstants.ROOT}
      >
        <h2 className={styles.header} data-test="leave-checkout-modal-title">
          Are you sure you want to leave checkout?
        </h2>
        <div
          className={styles.buttonWrap}
        >
          <PrimaryLink
            data-test="leave-checkout-modal-continue-button"
            external
            to={returnToJL()}
          >
            Yes, go to homepage
          </PrimaryLink>
          <SecondaryButton
            data-test="leave-checkout-modal-cancel-button"
            onClick={this.handleCloseModal}
          >
            No, stay in checkout
          </SecondaryButton>
        </div>
      </Modal>
    );
  }
}

export function mapStateToProps(state) {
  return {
    showModal: state.app.showLeaveCheckout,
  };
}

export function mapDispatchToProps() {
  return {
    closeLeaveCheckoutModal,
    go,
  };
}

export default connect(state => mapStateToProps(state), mapDispatchToProps())(LeaveCheckoutModal);
